// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"964":"5280f8d9","994":"5e335ec3"}[chunkId] + ".chunk.js";
};